document.querySelectorAll('[data-review-source]').forEach((note) => {
  if (note.dataset.ready) return;
  note.dataset.ready = 'true';
  const section = note.closest('section');
  const widget = section?.querySelector('#judgeme_product_reviews');
  const position = () => {
    if (!widget) return;
    const count = [...widget.querySelectorAll('p.jm-text')].find((p) => /^\d[\d,]* reviews?$/i.test(p.textContent.trim())) || widget.querySelector('.jdgm-rev-widg__summary-text');
    if (count && count.nextElementSibling !== note) count.after(note);
  };
  if (widget) {
    const observer = new MutationObserver(position);
    observer.observe(widget, { childList: true, subtree: true });
    position();
  }
  const button = note.querySelector('button');
  const text = note.querySelector('[role="note"]');
  if (!button || !text) return;
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const mobile = window.matchMedia('(max-width: 680px)');
  let pinned = false;
  const place = () => {
    if (mobile.matches) {
      // Keep the mobile note outside the review carousel's clipping and transforms.
      if (text.parentElement !== document.body) document.body.append(text);
    } else if (text.parentElement !== note) note.append(text);
  };
  const show = (open) => {
    if (open) place();
    text.hidden = !open;
    button.setAttribute('aria-expanded', String(open));
  };
  note.addEventListener('pointerenter', (event) => {
    if (hover.matches && event.pointerType === 'mouse') show(true);
  });
  note.addEventListener('pointerleave', (event) => {
    if (hover.matches && event.pointerType === 'mouse' && !pinned) show(false);
  });
  button.addEventListener('focus', () => { if (button.matches(':focus-visible')) show(true); });
  button.addEventListener('blur', () => { if (!pinned) show(false); });
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    pinned = !pinned;
    show(pinned);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !text.hidden) { pinned = false; show(false); }
  });
  document.addEventListener('pointerdown', (event) => {
    if (!note.contains(event.target) && !text.contains(event.target)) { pinned = false; show(false); }
  }, true);
  mobile.addEventListener('change', () => { if (!text.hidden) place(); });
});
